export default __webpack_public_path__ + "static/media/staking_bg_disable_button.ca00625c.png";